var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bet-console-prefix",style:(_vm.cssVars)},[_c('v-app',[_c('v-main',[_c('router-view'),_c('ScrollToTop'),(_vm.isDev)?_c('StoreDebugPanel'):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }